export function dateToIsoStart(date: string): string {
  return `${date}T00:00:00.000Z`;
}

export function dateToIsoEnd(date: string): string {
  return `${date}T23:59:59.999Z`;
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function isoOffsetDays(days: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - days);
  return d.toISOString().slice(0, 10);
}
